<template>
  <div @click="$emit('click')" class="modal-close">
    <icon name="cross"/>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
@import '~style/variables';

.modal-close {
  color: $c-text-mid;
  cursor: pointer;
  position: absolute;
  right: 1.25rem;
  top: 1.25rem;
}
</style>



// WEBPACK FOOTER //
// src/views/components/globals/ModalClose.vue